import NoData from "../../components/common/NoData";
import TextNavBackground from "../../components/common/TextNavBackground";
import PlayerProfileCard from "../../components/elements/players/PlayerProfileCard";
import { apiWrapper } from "../../utils/api/apiWrapper";
import { kKotokoPlayersLegendsListURL } from "../../utils/constants/apiUrls";
import { ONE_MONTH_REFRESH_INTERVAL_SECONDS } from "../../utils/constants/numbers";
import { LEGEND_LIST_URL } from "../../utils/constants/websiteUrls";
import {
  customStaticSeoConfig,
  getApiToken,
} from "../../utils/helpers/helpers";

const LegendList = ({ players }) => {
  // SAFE FIX: Provide default empty arrays for all positions to prevent destructuring & length crashes
  const {
    goalkeepers = [],
    defenders = [],
    midfielders = [],
    attackers = [],
  } = players || {};

  // SAFE FIX: Use our new safe variables for the empty state check
  const isAllEmpty =
    goalkeepers.length === 0 &&
    defenders.length === 0 &&
    midfielders.length === 0 &&
    attackers.length === 0;

  return (
    <>
      {customStaticSeoConfig("Asante Kotoko Legends")}

      <TextNavBackground title={"Legends"} />

      {isAllEmpty && <NoData />}

      <div className="mt-10 max-w-2xl mx-auto lg:max-w-7xl lg:px-8 px-6">
        {/** GOALKEEPERS */}
        {goalkeepers.length !== 0 && (
          <>
            <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
              Goalkeepers
            </h2>
            <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
              {goalkeepers.map((player) => (
                <a
                  key={player?.id || Math.random()}
                  href={`${LEGEND_LIST_URL}/${player?.slug || ""}`}
                  className="group"
                >
                  <PlayerProfileCard player={player} />
                </a>
              ))}
            </div>
          </>
        )}

        {/** DEFENDERS */}
        {defenders.length !== 0 && (
          <>
            <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
              Defenders
            </h2>
            <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
              {defenders.map((player) => (
                <a
                  key={player?.id || Math.random()}
                  href={`${LEGEND_LIST_URL}/${player?.slug || ""}`}
                  className="group"
                >
                  <PlayerProfileCard player={player} />
                </a>
              ))}
            </div>
          </>
        )}

        {/** MIDFIELDERS */}
        {midfielders.length !== 0 && (
          <>
            <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
              Midfielders
            </h2>
            <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
              {midfielders.map((player) => (
                <a
                  key={player?.id || Math.random()}
                  href={`${LEGEND_LIST_URL}/${player?.slug || ""}`}
                  className="group"
                >
                  <PlayerProfileCard player={player} />
                </a>
              ))}
            </div>
          </>
        )}

        {/** ATTACKERS */}
        {attackers.length !== 0 && (
          <>
            <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
              Attackers
            </h2>
            <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 mb-16">
              {attackers.map((player) => (
                <a
                  key={player?.id || Math.random()}
                  href={`${LEGEND_LIST_URL}/${player?.slug || ""}`}
                  className="group"
                >
                  <PlayerProfileCard player={player} />
                </a>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default LegendList;

export const getStaticProps = async (context) => {
  const token = getApiToken();
  const players = await apiWrapper.get(kKotokoPlayersLegendsListURL, token);

  return {
    props: {
      // SAFE FIX: Pass down empty object backup if API data resolution drops out
      players: players?.data || {},
    },
    revalidate: ONE_MONTH_REFRESH_INTERVAL_SECONDS,
  };
};
